import { render, staticRenderFns } from "./EventExport.vue?vue&type=template&id=646b966a&"
import script from "./EventExport.vue?vue&type=script&lang=ts&"
export * from "./EventExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports